import { Navigate, Outlet } from "react-router-dom";

import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { RoleEnum } from "@classview/shared-types";

export function EventGuard() {
  const { hasPermission } = useOrganisation();

  const hasEventsAccess = hasPermission(RoleEnum.EVENTS_VIEW);

  if (!hasEventsAccess) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}
